export default "__VITE_ASSET__5838843f__"